module.exports = __webpack_public_path__ + "static/media/jpg.9ff78d22.png";